import { BaseApiRequest, RobeSupportFiles } from "@robe/core";
import { useMemo } from "react";
import { useXcoreCore } from "./useXcoreCore";
import { useXcoreQuery } from "./useXcoreQuery";

export const useRobeSupportFiles = () => {
  const core = useXcoreCore();
  return useMemo(() => new RobeSupportFiles(core), [core]);
};

export const useSupportFilesQuery = <T>(req: (sf: RobeSupportFiles) => BaseApiRequest<T> | null) => {
  return useXcoreQuery((core) => {
    const sf = new RobeSupportFiles(core);
    return req(sf);
  });
};
